import React from "react";
import { AdvancedMarker } from "@vis.gl/react-google-maps";
import { Box } from "@salestrak/ui";

import {
  USER_LOCATION_DOT_COLOR as DOT_COLOR,
  USER_LOCATION_DOT_BG as DOT_BG,
} from "./map-styles";
import "./map-markers.css";

type UserLocationMarkerProps = {
  coordinate: { latitude: number; longitude: number };
};

export function UserLocationMarker({
  coordinate,
}: UserLocationMarkerProps) {
  return (
    <AdvancedMarker position={{ lat: coordinate.latitude, lng: coordinate.longitude }}>
      {/* The halo and the dot are both absolutely positioned, so the frame
        * declares `position="relative"` itself — Box is `position: static` by
        * default and they would escape to the map container. */}
      <Box height={40} position="relative" width={40}>
        {/* Dark circle that pulses outward and fades. Map markers sit on
          * imagery, not on a themed surface, so both colors arrive
          * pre-resolved from the map style rather than from a token. */}
        <Box
          height={32}
          left={4}
          position="absolute"
          rounded="full"
          style={{
            backgroundColor: DOT_BG,
            animation: "userLocationPulse 1.4s ease-out infinite",
          }}
          top={4}
          width={32}
        />

        {/* Static blue inner dot (above the pulse): a round Box with a hairline
          * ring draws the 16px disc without any raw markup. */}
        <Box
          height={16}
          left={12}
          position="absolute"
          rounded="full"
          style={{
            backgroundColor: DOT_COLOR,
            border: "1.5px solid #999",
          }}
          top={12}
          width={16}
          zIndex={1}
        />
      </Box>
    </AdvancedMarker>
  );
}
